import React from "react";

const Spinner = () => {
  return (
    <div className=" inline-block w-[30px] h-[30px] rounded-full border-[3px] border-t-black/20 border-r-black/20 animate-spin"></div>
  );
};

export default Spinner;
